
//Types
import { 
    MODIFICAR_FILTROS_SOLICITUD,
    CARGANDO_CONTROL_SOLICITUD,
    REINICIAR_FILTROS_SOLICITUD,
    CAMBIAR_FROM_SOLICITUD,
    SELECCIONAR_SOLICITUD,
    ACTUALIZAR_SOLICITUD,
        NOTIFICACION
} from "./solicitudesGLBActions";

const solicitudesGLBReducer = (state, action) => {
    switch(action.type){

        case MODIFICAR_FILTROS_SOLICITUD: {
            return {
                ...state,
                filtros: {...state.filtros, ...action.payload.filtros},
            }
        }
        
        case REINICIAR_FILTROS_SOLICITUD: {
            return {
                ...state,
                filtros: action.payload,
            }
        }


        case CARGANDO_CONTROL_SOLICITUD: {
            return {
                ...state,
                cargando: action.payload
            }
        }

        case CAMBIAR_FROM_SOLICITUD: {
            return {
                ...state,
                from: action.payload
            }
        }

        case SELECCIONAR_SOLICITUD: {
            return {
                ...state,
                solicitudSelected: action.payload
            }
        }

        case ACTUALIZAR_SOLICITUD: {
            return {
                ...state,
                solicitudSelected: action.payload
            }
        }

        case NOTIFICACION: {
            return {
                ...state,
                notificacion: action.payload
            }
        }


        default:
            return state;
    }
}

export default solicitudesGLBReducer;